import React from "react";
import { Form } from "react-bootstrap";
import { TChannelOption } from "../../../../../api/endpoints/SubsetOption";
import ChannelsSelector from "../../../ChannelsSelector";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TChannelOption;
}

const SatelliteChannelsField = (props: Props) => {
  const { formik, spec } = props;

  return (
    <Form.Group controlId="channels">
      <Form.Label>Satellite channels</Form.Label>
      <ChannelsSelector
        values={formik.values.channel}
        spec={spec}
        onChange={values => formik.setFieldValue('channel', values)}
      />

      <FormError
        message={formik.errors.channel as TFormErrorMessage}
        when={formik.touched.channel && Boolean(formik.errors.channel)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  );
}

export default SatelliteChannelsField;
